import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoUI } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoUI } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoUIClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoUIClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoHttpHandlerResponseV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoHttpHandlerRequestV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoHttpHandlerResponseV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoHttpHandlerRequestV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";

export interface IIsiDtoAutoRefreshSettings extends IIsiDataTransferObject  {
    period?: number;
    type?: string;
}
export class IsiDtoAutoRefreshSettings extends IsiDataTransferObject implements IIsiDtoAutoRefreshSettings {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoAutoRefreshSettings, Isilog.IsiComponent.IsiDataTransferObject";
    period?: number;
    type?: string;

    constructor(data?: IIsiDtoAutoRefreshSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.period = _data["period"] !== undefined ? _data["period"] : 0;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoAutoRefreshSettings): IsiDtoAutoRefreshSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAutoRefreshSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["period"] = this.period !== undefined ? this.period : 0;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}
export interface IIsiDtoIwsUI extends IIsiDtoUI  {
    dockedBarFormSettings?: IIsiDtoDockedBar;
    autoRefreshSettings?: IIsiDtoAutoRefreshSettings;
    syncCollapseScreenList?: boolean;
    gridManagerSettings?: IIsiDtoIwsGridManagerClientSettings;
    menuManagerSettings?: IIsiDtoMenuManagerClientSettings;
    screen?: IIsiDtoIwsUIScreen;
    bindSwitchMode?: boolean;
    cursorState?: string;
}
export interface IIsiDtoDockedBar extends IIsiDataTransferObject  {
    listIdButtonIgnoreNbMax?: string[];
    nbMaxActionBar?: number;
}
export class IsiDtoDockedBar extends IsiDataTransferObject implements IIsiDtoDockedBar {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.IsiDtoDockedBar, Isilog.IsiComponent.IsiDataTransferObject";
    listIdButtonIgnoreNbMax?: string[];
    nbMaxActionBar?: number;

    constructor(data?: IIsiDtoDockedBar) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listIdButtonIgnoreNbMax = _data["listIdButtonIgnoreNbMax"];
            this.nbMaxActionBar = _data["nbMaxActionBar"] !== undefined ? _data["nbMaxActionBar"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoDockedBar): IsiDtoDockedBar {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoDockedBar();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["listIdButtonIgnoreNbMax"] = this.listIdButtonIgnoreNbMax !== undefined ? this.listIdButtonIgnoreNbMax : [];
        data["nbMaxActionBar"] = this.nbMaxActionBar !== undefined ? this.nbMaxActionBar : 0;
        return data;
    }
}
export interface IIsiDtoIwsGridManagerClientSettings extends IIsiDataTransferObject  {
    searchType?: IsiGridType;
}
export enum IsiGridType {
    None = 0,
    SearchFromQuery = 1,
    SearchFromCursor = 2,
    SearchFromTextConnexe = 3,
    SearchFromAssociation = 4,
    SearchFromDissociation = 5,
    SearchFromForm = 6,
}
export class IsiDtoIwsGridManagerClientSettings extends IsiDataTransferObject implements IIsiDtoIwsGridManagerClientSettings {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Grid.Client.IsiDtoIwsGridManagerClientSettings, Isilog.IsiComponent.IsiDataTransferObject";
    searchType?: IsiGridType;

    constructor(data?: IIsiDtoIwsGridManagerClientSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchType = _data["searchType"] !== undefined ? _data["searchType"] : IsiGridType.None;
        }
    }

    static fromJS(data?: IIsiDtoIwsGridManagerClientSettings): IsiDtoIwsGridManagerClientSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsGridManagerClientSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["searchType"] = this.searchType !== undefined ? this.searchType : IsiGridType.None;
        return data;
    }
}
export interface IIsiDtoMenuManagerClientSettings extends IIsiDataTransferObject  {
    implicitValid?: string[];
    menuEntriesIdByClientId?: { [key: string]: string; };
    menuEntriesIdByBarAndKey?: { [key: string]: { [key: string]: string; }; };
    menuEntriesById?: { [key: string]: IIsiDtoMenuObject; };
    tempoCountDetail?: number;
}
export interface IIsiDtoMenuBase extends IIsiDataTransferObject  {
    data?: { [key: string]: string; };
    id?: string;
}
export interface IIsiDtoMenuObject extends IIsiDtoMenuBase  {
    isVisble?: boolean;
    optionUrl?: string;
    key?: string;
    clientIds?: string[];
    shortLabel?: string;
    label?: string;
    group?: string;
    bar?: string;
}
export class IsiDtoMenuManagerClientSettings extends IsiDataTransferObject implements IIsiDtoMenuManagerClientSettings {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoMenuManagerClientSettings, Isilog.IsiComponent.IsiDataTransferObject";
    implicitValid?: string[];
    menuEntriesIdByClientId?: { [key: string]: string; };
    menuEntriesIdByBarAndKey?: { [key: string]: { [key: string]: string; }; };
    menuEntriesById?: { [key: string]: IIsiDtoMenuObject; };
    tempoCountDetail?: number;

    constructor(data?: IIsiDtoMenuManagerClientSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.implicitValid = _data["implicitValid"];
            this.menuEntriesIdByClientId = _data["menuEntriesIdByClientId"];
            this.menuEntriesIdByBarAndKey = _data["menuEntriesIdByBarAndKey"];
            this.menuEntriesById = _data["menuEntriesById"];
            this.tempoCountDetail = _data["tempoCountDetail"] !== undefined ? _data["tempoCountDetail"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoMenuManagerClientSettings): IsiDtoMenuManagerClientSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoMenuManagerClientSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["implicitValid"] = this.implicitValid !== undefined ? this.implicitValid : [];
        data["menuEntriesIdByClientId"] = this.menuEntriesIdByClientId !== undefined ? this.menuEntriesIdByClientId : <any>null;
        data["menuEntriesIdByBarAndKey"] = this.menuEntriesIdByBarAndKey !== undefined ? this.menuEntriesIdByBarAndKey : <any>null;
        data["menuEntriesById"] = this.menuEntriesById !== undefined ? this.menuEntriesById : <any>null;
        data["tempoCountDetail"] = this.tempoCountDetail !== undefined ? this.tempoCountDetail : 0;
        return data;
    }
}
export interface IIsiDtoIwsUIScreen extends IIsiDataTransferObject  {
    rwdWidth?: string;
    connect?: boolean;
    ecranDispo?: string;
    langue?: string;
    bureauPere?: number;
    bureau?: number;
    module?: string;
    accessType?: string;
    useContext?: string;
    type?: string;
    table?: string;
    father?: string;
    name?: string;
    typeScript?: string;
}
export class IsiDtoIwsUIScreen extends IsiDataTransferObject implements IIsiDtoIwsUIScreen {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoIwsUIScreen, Isilog.IsiComponent.IsiDataTransferObject";
    rwdWidth?: string;
    connect?: boolean;
    ecranDispo?: string;
    langue?: string;
    bureauPere?: number;
    bureau?: number;
    module?: string;
    accessType?: string;
    useContext?: string;
    type?: string;
    table?: string;
    father?: string;
    name?: string;
    typeScript?: string;

    constructor(data?: IIsiDtoIwsUIScreen) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rwdWidth = _data["rwdWidth"] !== undefined ? _data["rwdWidth"] : <any>null;
            this.connect = _data["connect"] !== undefined ? _data["connect"] : false;
            this.ecranDispo = _data["ecranDispo"] !== undefined ? _data["ecranDispo"] : <any>null;
            this.langue = _data["langue"] !== undefined ? _data["langue"] : <any>null;
            this.bureauPere = _data["bureauPere"] !== undefined ? _data["bureauPere"] : 0;
            this.bureau = _data["bureau"] !== undefined ? _data["bureau"] : 0;
            this.module = _data["module"] !== undefined ? _data["module"] : <any>null;
            this.accessType = _data["accessType"] !== undefined ? _data["accessType"] : <any>null;
            this.useContext = _data["useContext"] !== undefined ? _data["useContext"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.table = _data["table"] !== undefined ? _data["table"] : <any>null;
            this.father = _data["father"] !== undefined ? _data["father"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.typeScript = _data["typeScript"] !== undefined ? _data["typeScript"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsUIScreen): IsiDtoIwsUIScreen {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsUIScreen();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["rwdWidth"] = this.rwdWidth !== undefined ? this.rwdWidth : <any>null;
        data["connect"] = this.connect !== undefined ? this.connect : false;
        data["ecranDispo"] = this.ecranDispo !== undefined ? this.ecranDispo : <any>null;
        data["langue"] = this.langue !== undefined ? this.langue : <any>null;
        data["bureauPere"] = this.bureauPere !== undefined ? this.bureauPere : 0;
        data["bureau"] = this.bureau !== undefined ? this.bureau : 0;
        data["module"] = this.module !== undefined ? this.module : <any>null;
        data["accessType"] = this.accessType !== undefined ? this.accessType : <any>null;
        data["useContext"] = this.useContext !== undefined ? this.useContext : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["table"] = this.table !== undefined ? this.table : <any>null;
        data["father"] = this.father !== undefined ? this.father : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["typeScript"] = this.typeScript !== undefined ? this.typeScript : <any>null;
        return data;
    }
}
export class IsiDtoIwsUI extends IsiDtoUI implements IIsiDtoIwsUI {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoIwsUI, Isilog.IsiComponent.IsiDataTransferObject";
    dockedBarFormSettings?: IsiDtoDockedBar;
    autoRefreshSettings?: IsiDtoAutoRefreshSettings;
    syncCollapseScreenList?: boolean;
    gridManagerSettings?: IsiDtoIwsGridManagerClientSettings;
    menuManagerSettings?: IsiDtoMenuManagerClientSettings;
    screen?: IsiDtoIwsUIScreen;
    bindSwitchMode?: boolean;
    cursorState?: string;

    constructor(data?: IIsiDtoIwsUI) {
        super(data);
        if (data) {
            this.dockedBarFormSettings = data.dockedBarFormSettings && !(<any>data.dockedBarFormSettings).toJSON ? new IsiDtoDockedBar(data.dockedBarFormSettings) : <IsiDtoDockedBar>this.dockedBarFormSettings;
            this.autoRefreshSettings = data.autoRefreshSettings && !(<any>data.autoRefreshSettings).toJSON ? new IsiDtoAutoRefreshSettings(data.autoRefreshSettings) : <IsiDtoAutoRefreshSettings>this.autoRefreshSettings;
            this.gridManagerSettings = data.gridManagerSettings && !(<any>data.gridManagerSettings).toJSON ? new IsiDtoIwsGridManagerClientSettings(data.gridManagerSettings) : <IsiDtoIwsGridManagerClientSettings>this.gridManagerSettings;
            this.menuManagerSettings = data.menuManagerSettings && !(<any>data.menuManagerSettings).toJSON ? new IsiDtoMenuManagerClientSettings(data.menuManagerSettings) : <IsiDtoMenuManagerClientSettings>this.menuManagerSettings;
            this.screen = data.screen && !(<any>data.screen).toJSON ? new IsiDtoIwsUIScreen(data.screen) : <IsiDtoIwsUIScreen>this.screen;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dockedBarFormSettings = _data["dockedBarFormSettings"] ? IsiDtoDockedBar.fromJS(_data["dockedBarFormSettings"]) : <any>null;
            this.autoRefreshSettings = _data["autoRefreshSettings"] ? IsiDtoAutoRefreshSettings.fromJS(_data["autoRefreshSettings"]) : <any>null;
            this.syncCollapseScreenList = _data["syncCollapseScreenList"] !== undefined ? _data["syncCollapseScreenList"] : false;
            this.gridManagerSettings = _data["gridManagerSettings"] ? IsiDtoIwsGridManagerClientSettings.fromJS(_data["gridManagerSettings"]) : <any>null;
            this.menuManagerSettings = _data["menuManagerSettings"] ? IsiDtoMenuManagerClientSettings.fromJS(_data["menuManagerSettings"]) : <any>null;
            this.screen = _data["screen"] ? IsiDtoIwsUIScreen.fromJS(_data["screen"]) : <any>null;
            this.bindSwitchMode = _data["bindSwitchMode"] !== undefined ? _data["bindSwitchMode"] : false;
            this.cursorState = _data["cursorState"] !== undefined ? _data["cursorState"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsUI): IsiDtoIwsUI {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["dockedBarFormSettings"] = this.dockedBarFormSettings != null ? (<any>this.dockedBarFormSettings).toJSON() : <any>null;
        data["autoRefreshSettings"] = this.autoRefreshSettings != null ? (<any>this.autoRefreshSettings).toJSON() : <any>null;
        data["syncCollapseScreenList"] = this.syncCollapseScreenList !== undefined ? this.syncCollapseScreenList : false;
        data["gridManagerSettings"] = this.gridManagerSettings != null ? (<any>this.gridManagerSettings).toJSON() : <any>null;
        data["menuManagerSettings"] = this.menuManagerSettings != null ? (<any>this.menuManagerSettings).toJSON() : <any>null;
        data["screen"] = this.screen != null ? (<any>this.screen).toJSON() : <any>null;
        data["bindSwitchMode"] = this.bindSwitchMode !== undefined ? this.bindSwitchMode : false;
        data["cursorState"] = this.cursorState !== undefined ? this.cursorState : <any>null;
        return data;
    }
}
export interface IIsiDtoIwsUIClientState extends IIsiDtoUIClientState  {
    uiActionEntitiesInfoForRedirect?: { [key: string]: IIsiDtoIwsUIEntityInfos; };
    uiActionContextIdForRedirect?: string;
    uiActionIdForRedirect?: string;
    uiActionContextId?: string;
    uiActionId?: string;
    formManager?: IIsiDtoFormManagerClientState;
    gridManager?: IIsiDtoIwsGridManagerClientState;
    associatedViewManager?: IIsiDtoAssociatedViewManagerClientState;
    menuManager?: IIsiDtoMenuManagerClientState;
}
export interface IIsiDtoIwsUIEntityInfos extends IIsiDataTransferObject  {
    businessOtherInfos?: { [key: string]: any; };
    businessInfos?: { [key: string]: any; };
}
export class IsiDtoIwsUIEntityInfos extends IsiDataTransferObject implements IIsiDtoIwsUIEntityInfos {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoIwsUIEntityInfos, Isilog.IsiComponent.IsiDataTransferObject";
    businessOtherInfos?: { [key: string]: any; };
    businessInfos?: { [key: string]: any; };

    constructor(data?: IIsiDtoIwsUIEntityInfos) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.businessOtherInfos = _data["businessOtherInfos"] !== undefined ? _data["businessOtherInfos"] : <any>null;
            this.businessInfos = _data["businessInfos"] !== undefined ? _data["businessInfos"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsUIEntityInfos): IsiDtoIwsUIEntityInfos {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsUIEntityInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["businessOtherInfos"] = this.businessOtherInfos !== undefined ? this.businessOtherInfos : <any>null;
        data["businessInfos"] = this.businessInfos !== undefined ? this.businessInfos : <any>null;
        return data;
    }
}
export interface IIsiDtoFormManagerClientState extends IIsiDataTransferObject  {
    translationHardDeletionControls?: string[];
    canDelete?: boolean;
    canAdd?: boolean;
    canModify?: boolean;
}
export class IsiDtoFormManagerClientState extends IsiDataTransferObject implements IIsiDtoFormManagerClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.IsiDtoFormManagerClientState, Isilog.IsiComponent.IsiDataTransferObject";
    translationHardDeletionControls?: string[];
    canDelete?: boolean;
    canAdd?: boolean;
    canModify?: boolean;

    constructor(data?: IIsiDtoFormManagerClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.translationHardDeletionControls = _data["translationHardDeletionControls"];
            this.canDelete = _data["canDelete"] !== undefined ? _data["canDelete"] : false;
            this.canAdd = _data["canAdd"] !== undefined ? _data["canAdd"] : false;
            this.canModify = _data["canModify"] !== undefined ? _data["canModify"] : false;
        }
    }

    static fromJS(data?: IIsiDtoFormManagerClientState): IsiDtoFormManagerClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoFormManagerClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["translationHardDeletionControls"] = this.translationHardDeletionControls !== undefined ? this.translationHardDeletionControls : [];
        data["canDelete"] = this.canDelete !== undefined ? this.canDelete : false;
        data["canAdd"] = this.canAdd !== undefined ? this.canAdd : false;
        data["canModify"] = this.canModify !== undefined ? this.canModify : false;
        return data;
    }
}
export interface IIsiDtoIwsGridManagerClientState extends IIsiDataTransferObject  {
    mainStateId?: string;
}
export class IsiDtoIwsGridManagerClientState extends IsiDataTransferObject implements IIsiDtoIwsGridManagerClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Grid.Client.IsiDtoIwsGridManagerClientState, Isilog.IsiComponent.IsiDataTransferObject";
    mainStateId?: string;

    constructor(data?: IIsiDtoIwsGridManagerClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mainStateId = _data["mainStateId"] !== undefined ? _data["mainStateId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsGridManagerClientState): IsiDtoIwsGridManagerClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsGridManagerClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["mainStateId"] = this.mainStateId !== undefined ? this.mainStateId : <any>null;
        return data;
    }
}
export interface IIsiDtoAssociatedViewManagerClientState extends IIsiDataTransferObject  {
    focusOnDetail?: boolean;
    shownContextId?: string;
    associatedViewPosition?: DetailState;
    isDefaultView?: boolean;
    displayDetailImplicitely?: boolean;
    states?: { [key: string]: IIsiDtoIwsAssociatedViewClientState; };
}
export enum DetailState {
    None = 0,
    Down = 1,
    Up = 2,
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewClientState extends IIsiDtoComponentClientState  {
    /** Indique si tous les groupement on été supprimé côté client */
    allGrpRemoved?: boolean;
    /** Contient le modification effectuées sur les colonnes par l'utilisateur par rapport à la configuration en base */
    columnsState?: { [key: string]: IIsiDtoGridViewColumnClientState; };
    activeRow?: IIsiDtoGridViewSelectedRowClientState;
    selectedRows?: IIsiDtoGridViewSelectedRowsClientState;
    gridViewId?: string;
    /** Filtre de recherche rapide */
    gridViewFilter?: string;
    allLinesSelected?: boolean;
    gridState?: IIsiDtoGridClientState;
}
/** Représente l'état du composant IIsiAssociatedView coté client */
export interface IIsiDtoAssociatedViewClientState extends IIsiDtoGridViewClientState  {
}
export interface IIsiDtoIwsGridViewClientState extends IIsiDtoGridViewClientState  {
}
export interface IIsiDtoIwsAssociatedViewClientState extends IIsiDtoAssociatedViewClientState,IIsiDtoIwsGridViewClientState  {
    scriptNameForTs?: string;
    linkContext?: IIsiDtoIwsAssociatedViewLinkClientState;
    searchType?: number;
    showCounter?: boolean;
    actionAfterDragNDrop?: string;
    autoRefreshPeriod?: number;
    autoRefresh?: boolean;
    gridType?: GridType;
    useTS?: boolean;
    contextId?: string;
    module?: string;
    name?: string;
}
/** Etat des modifications cliente des colonnes */
export interface IIsiDtoGridViewColumnClientState extends IIsiDataTransferObject  {
    /** Indique Le tri y compris si la colonne a été groupée */
    sorting?: string;
    /** Si != -1 la colonne est groupée */
    grpIndex?: number;
}
export class IsiDtoGridViewColumnClientState extends IsiDataTransferObject implements IIsiDtoGridViewColumnClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewColumnClientState, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique Le tri y compris si la colonne a été groupée */
    sorting?: string;
    /** Si != -1 la colonne est groupée */
    grpIndex?: number;

    constructor(data?: IIsiDtoGridViewColumnClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sorting = _data["sorting"] !== undefined ? _data["sorting"] : <any>null;
            this.grpIndex = _data["grpIndex"] !== undefined ? _data["grpIndex"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGridViewColumnClientState): IsiDtoGridViewColumnClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewColumnClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sorting"] = this.sorting !== undefined ? this.sorting : <any>null;
        data["grpIndex"] = this.grpIndex !== undefined ? this.grpIndex : 0;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewSelectedRowClientState extends IIsiDataTransferObject  {
    datas?: { [key: string]: any; };
    realKey?: { [key: string]: string; };
    key?: string;
}
export class IsiDtoGridViewSelectedRowClientState extends IsiDataTransferObject implements IIsiDtoGridViewSelectedRowClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewSelectedRowClientState, Isilog.IsiFramework.IsiDataTransferObject";
    datas?: { [key: string]: any; };
    realKey?: { [key: string]: string; };
    key?: string;

    constructor(data?: IIsiDtoGridViewSelectedRowClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datas = _data["datas"] !== undefined ? _data["datas"] : <any>null;
            this.realKey = _data["realKey"];
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridViewSelectedRowClientState): IsiDtoGridViewSelectedRowClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewSelectedRowClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["datas"] = this.datas !== undefined ? this.datas : <any>null;
        data["realKey"] = this.realKey !== undefined ? this.realKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridViewSelectedRowsClientState extends IIsiDataTransferObject  {
    rows?: IIsiDtoGridViewSelectedRowClientState[];
}
export class IsiDtoGridViewSelectedRowsClientState extends IsiDataTransferObject implements IIsiDtoGridViewSelectedRowsClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewSelectedRowsClientState, Isilog.IsiFramework.IsiDataTransferObject";
    rows?: IIsiDtoGridViewSelectedRowClientState[];

    constructor(data?: IIsiDtoGridViewSelectedRowsClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rows = _data["rows"];
        }
    }

    static fromJS(data?: IIsiDtoGridViewSelectedRowsClientState): IsiDtoGridViewSelectedRowsClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewSelectedRowsClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["rows"] = this.rows !== undefined ? this.rows : [];
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridClientState extends IIsiDtoComponentClientState  {
    features?: IIsiDtoGridFeaturesClientState;
    columns?: IIsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IIsiDtoGridSelectedRow;
    selectedRows?: IIsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;
}
export interface IIsiDtoGridFeaturesClientState extends IIsiDataTransferObject  {
    sorting?: IIsiDtoGridSortingFeatureClientState;
    filtering?: IIsiDtoGridFilteringFeatureClientState;
}
export interface IIsiDtoGridSortingFeatureClientState extends IIsiDataTransferObject  {
    columnSettings?: any[];
}
export class IsiDtoGridSortingFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridSortingFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSortingFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    columnSettings?: any[];

    constructor(data?: IIsiDtoGridSortingFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnSettings = _data["columnSettings"];
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureClientState): IsiDtoGridSortingFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        return data;
    }
}
export interface IIsiDtoGridFilteringFeatureClientState extends IIsiDataTransferObject  {
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];
}
export class IsiDtoGridFilteringFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridFilteringFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFilteringFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];

    constructor(data?: IIsiDtoGridFilteringFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.globalFilterValue = _data["globalFilterValue"] !== undefined ? _data["globalFilterValue"] : <any>null;
            this.columnSettings = _data["columnSettings"];
            this.filtersByColumn = _data["filtersByColumn"];
            this.filters = _data["filters"];
        }
    }

    static fromJS(data?: IIsiDtoGridFilteringFeatureClientState): IsiDtoGridFilteringFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFilteringFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["globalFilterValue"] = this.globalFilterValue !== undefined ? this.globalFilterValue : <any>null;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        data["filtersByColumn"] = this.filtersByColumn !== undefined ? this.filtersByColumn : [];
        data["filters"] = this.filters !== undefined ? this.filters : [];
        return data;
    }
}
export class IsiDtoGridFeaturesClientState extends IsiDataTransferObject implements IIsiDtoGridFeaturesClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFeaturesClientState, Isilog.IsiFramework.IsiDataTransferObject";
    sorting?: IsiDtoGridSortingFeatureClientState;
    filtering?: IsiDtoGridFilteringFeatureClientState;

    constructor(data?: IIsiDtoGridFeaturesClientState) {
        super(data);
        if (data) {
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureClientState(data.sorting) : <IsiDtoGridSortingFeatureClientState>this.sorting;
            this.filtering = data.filtering && !(<any>data.filtering).toJSON ? new IsiDtoGridFilteringFeatureClientState(data.filtering) : <IsiDtoGridFilteringFeatureClientState>this.filtering;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureClientState.fromJS(_data["sorting"]) : <any>null;
            this.filtering = _data["filtering"] ? IsiDtoGridFilteringFeatureClientState.fromJS(_data["filtering"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridFeaturesClientState): IsiDtoGridFeaturesClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFeaturesClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["filtering"] = this.filtering != null ? (<any>this.filtering).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoGridColumn extends IIsiDataTransferObject  {
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IIsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IIsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;
}
export enum TypeAggregation {
    Text = 0,
    Somme = 1,
    Moyenne = 2,
    Minimum = 3,
    Maximum = 4,
    Count = 5,
    None = 6,
}
export enum TypeCtrl {
    None = 0,
    MultilineText = 1,
    Connexe = 2,
    Others = -1,
}
export enum CtrlFormat {
    None = 0,
    Text = 1,
    Numerical = 2,
    Price = 3,
    Amount = 4,
    Boolean = 5,
    Date = 6,
    Hour = 7,
    DateHour = 8,
    RichText = 9,
}
export enum EscapeType {
    None = 0,
    Encode = 1,
    Sanitarize = 2,
}
/** Les types de rendu possibles pour une colonne. */
export enum ColumnRenderTypes {
    Custom = 0,
    Boolean = 1,
    Checkbox = 2,
}
export interface IIsiDtoGridColumnSettings extends IIsiDataTransferObject  {
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridUpdatingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridColumnSettings extends IsiDataTransferObject implements IIsiDtoGridColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridColumnSettings): IsiDtoGridColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridUpdatingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridUpdatingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridUpdatingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;

    constructor(data?: IIsiDtoGridUpdatingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : false;
            this.req = _data["req"] !== undefined ? _data["req"] : false;
            this.eT = _data["eT"] !== undefined ? _data["eT"] : "text";
            this.edVK = _data["edVK"] !== undefined ? _data["edVK"] : <any>null;
            this.edTK = _data["edTK"] !== undefined ? _data["edTK"] : <any>null;
            this.edUrl = _data["edUrl"] !== undefined ? _data["edUrl"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridUpdatingFeatureColumnSettings): IsiDtoGridUpdatingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridUpdatingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : false;
        data["req"] = this.req !== undefined ? this.req : false;
        data["eT"] = this.eT !== undefined ? this.eT : "text";
        data["edVK"] = this.edVK !== undefined ? this.edVK : <any>null;
        data["edTK"] = this.edTK !== undefined ? this.edTK : <any>null;
        data["edUrl"] = this.edUrl !== undefined ? this.edUrl : <any>null;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridSortingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    direction?: string;
    allowSorting?: boolean;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridSortingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridSortingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridSortingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    direction?: string;
    allowSorting?: boolean;

    constructor(data?: IIsiDtoGridSortingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.direction = _data["direction"] !== undefined ? _data["direction"] : "False";
            this.allowSorting = _data["allowSorting"] !== undefined ? _data["allowSorting"] : true;
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureColumnSettings): IsiDtoGridSortingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["direction"] = this.direction !== undefined ? this.direction : "False";
        data["allowSorting"] = this.allowSorting !== undefined ? this.allowSorting : true;
        return data;
    }
}
export class IsiDtoGridColumn extends IsiDataTransferObject implements IIsiDtoGridColumn {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridColumn, Isilog.IsiFramework.IsiDataTransferObject";
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;

    constructor(data?: IIsiDtoGridColumn) {
        super(data);
        if (data) {
            this.updating = data.updating && !(<any>data.updating).toJSON ? new IsiDtoGridUpdatingFeatureColumnSettings(data.updating) : <IsiDtoGridUpdatingFeatureColumnSettings>this.updating;
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureColumnSettings(data.sorting) : <IsiDtoGridSortingFeatureColumnSettings>this.sorting;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.headerTooltip = _data["headerTooltip"] !== undefined ? _data["headerTooltip"] : <any>null;
            this.typeAggreg = _data["typeAggreg"] !== undefined ? _data["typeAggreg"] : TypeAggregation.Text;
            this.columnIndex = _data["columnIndex"] !== undefined ? _data["columnIndex"] : 0;
            this.allowTooltips = _data["allowTooltips"] !== undefined ? _data["allowTooltips"] : false;
            this.columnRacc = _data["columnRacc"] !== undefined ? _data["columnRacc"] : <any>null;
            this.associateFormCtrlType = _data["associateFormCtrlType"] !== undefined ? _data["associateFormCtrlType"] : TypeCtrl.None;
            this.alignRight = _data["alignRight"] !== undefined ? _data["alignRight"] : false;
            this.ctrlFormat = _data["ctrlFormat"] !== undefined ? _data["ctrlFormat"] : CtrlFormat.None;
            this.fieldLength = _data["fieldLength"] !== undefined ? _data["fieldLength"] : 0;
            this.dataSourceId = _data["dataSourceId"] !== undefined ? _data["dataSourceId"] : <any>null;
            this.escapeHtml = _data["escapeHtml"] !== undefined ? _data["escapeHtml"] : EscapeType.None;
            this.unbound = _data["unbound"] !== undefined ? _data["unbound"] : false;
            this.formula = _data["formula"] !== undefined ? _data["formula"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.renderType = _data["renderType"] !== undefined ? _data["renderType"] : ColumnRenderTypes.Custom;
            this.formatter = _data["formatter"] !== undefined ? _data["formatter"] : <any>null;
            this.columnCssClass = _data["columnCssClass"] !== undefined ? _data["columnCssClass"] : <any>null;
            this.headerCssClass = _data["headerCssClass"] !== undefined ? _data["headerCssClass"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.textColumnKey = _data["textColumnKey"] !== undefined ? _data["textColumnKey"] : <any>null;
            this.updating = _data["updating"] ? IsiDtoGridUpdatingFeatureColumnSettings.fromJS(_data["updating"]) : <any>null;
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureColumnSettings.fromJS(_data["sorting"]) : <any>null;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : false;
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : <any>null;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridColumn): IsiDtoGridColumn {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["headerTooltip"] = this.headerTooltip !== undefined ? this.headerTooltip : <any>null;
        data["typeAggreg"] = this.typeAggreg !== undefined ? this.typeAggreg : TypeAggregation.Text;
        data["columnIndex"] = this.columnIndex !== undefined ? this.columnIndex : 0;
        data["allowTooltips"] = this.allowTooltips !== undefined ? this.allowTooltips : false;
        data["columnRacc"] = this.columnRacc !== undefined ? this.columnRacc : <any>null;
        data["associateFormCtrlType"] = this.associateFormCtrlType !== undefined ? this.associateFormCtrlType : TypeCtrl.None;
        data["alignRight"] = this.alignRight !== undefined ? this.alignRight : false;
        data["ctrlFormat"] = this.ctrlFormat !== undefined ? this.ctrlFormat : CtrlFormat.None;
        data["fieldLength"] = this.fieldLength !== undefined ? this.fieldLength : 0;
        data["dataSourceId"] = this.dataSourceId !== undefined ? this.dataSourceId : <any>null;
        data["escapeHtml"] = this.escapeHtml !== undefined ? this.escapeHtml : EscapeType.None;
        data["unbound"] = this.unbound !== undefined ? this.unbound : false;
        data["formula"] = this.formula !== undefined ? this.formula : <any>null;
        data["id"] = this.id !== undefined ? this.id : 0;
        data["renderType"] = this.renderType !== undefined ? this.renderType : ColumnRenderTypes.Custom;
        data["formatter"] = this.formatter !== undefined ? this.formatter : <any>null;
        data["columnCssClass"] = this.columnCssClass !== undefined ? this.columnCssClass : <any>null;
        data["headerCssClass"] = this.headerCssClass !== undefined ? this.headerCssClass : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["textColumnKey"] = this.textColumnKey !== undefined ? this.textColumnKey : <any>null;
        data["updating"] = this.updating != null ? (<any>this.updating).toJSON() : <any>null;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["hidden"] = this.hidden !== undefined ? this.hidden : false;
        data["headerText"] = this.headerText !== undefined ? this.headerText : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridSelectedRow extends IIsiDataTransferObject  {
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridSelectedRow extends IsiDataTransferObject implements IIsiDtoGridSelectedRow {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSelectedRow, Isilog.IsiFramework.IsiDataTransferObject";
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;

    constructor(data?: IIsiDtoGridSelectedRow) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datas = _data["datas"];
            this.realKey = _data["realKey"];
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridSelectedRow): IsiDtoGridSelectedRow {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSelectedRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["datas"] = this.datas !== undefined ? this.datas : <any>null;
        data["realKey"] = this.realKey !== undefined ? this.realKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridClientState extends IsiDtoComponentClientState implements IIsiDtoGridClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridClientState, Isilog.IsiFramework.IsiDataTransferObject";
    features?: IsiDtoGridFeaturesClientState;
    columns?: IsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IsiDtoGridSelectedRow;
    selectedRows?: IsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;

    constructor(data?: IIsiDtoGridClientState) {
        super(data);
        if (data) {
            this.features = data.features && !(<any>data.features).toJSON ? new IsiDtoGridFeaturesClientState(data.features) : <IsiDtoGridFeaturesClientState>this.features;
            this.activeRow = data.activeRow && !(<any>data.activeRow).toJSON ? new IsiDtoGridSelectedRow(data.activeRow) : <IsiDtoGridSelectedRow>this.activeRow;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.features = _data["features"] ? IsiDtoGridFeaturesClientState.fromJS(_data["features"]) : <any>null;
            this.columns = _data["columns"] !== undefined ? _data["columns"] : [];
            this.data = _data["data"];
            this.totalLocalRecordsCount = _data["totalLocalRecordsCount"] !== undefined ? _data["totalLocalRecordsCount"] : 0;
            this.totalRecordCount = _data["totalRecordCount"] !== undefined ? _data["totalRecordCount"] : 0;
            this.scrollTop = _data["scrollTop"] !== undefined ? _data["scrollTop"] : 0;
            this.activeRow = _data["activeRow"] ? IsiDtoGridSelectedRow.fromJS(_data["activeRow"]) : <any>null;
            this.selectedRows = _data["selectedRows"] !== undefined ? _data["selectedRows"] : [];
            this.allLinesSelected = _data["allLinesSelected"] !== undefined ? _data["allLinesSelected"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridClientState): IsiDtoGridClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["features"] = this.features != null ? (<any>this.features).toJSON() : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        data["data"] = this.data !== undefined ? this.data : [];
        data["totalLocalRecordsCount"] = this.totalLocalRecordsCount !== undefined ? this.totalLocalRecordsCount : 0;
        data["totalRecordCount"] = this.totalRecordCount !== undefined ? this.totalRecordCount : 0;
        data["scrollTop"] = this.scrollTop !== undefined ? this.scrollTop : 0;
        data["activeRow"] = this.activeRow != null ? (<any>this.activeRow).toJSON() : <any>null;
        data["selectedRows"] = this.selectedRows !== undefined ? this.selectedRows : [];
        data["allLinesSelected"] = this.allLinesSelected !== undefined ? this.allLinesSelected : false;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridViewClientState extends IsiDtoComponentClientState implements IIsiDtoGridViewClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.IsiDtoGridViewClientState, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique si tous les groupement on été supprimé côté client */
    allGrpRemoved?: boolean;
    /** Contient le modification effectuées sur les colonnes par l'utilisateur par rapport à la configuration en base */
    columnsState?: { [key: string]: IsiDtoGridViewColumnClientState; };
    activeRow?: IsiDtoGridViewSelectedRowClientState;
    selectedRows!: IsiDtoGridViewSelectedRowsClientState;
    gridViewId?: string;
    /** Filtre de recherche rapide */
    gridViewFilter?: string;
    allLinesSelected?: boolean;
    gridState?: IsiDtoGridClientState;

    constructor(data?: IIsiDtoGridViewClientState) {
        super(data);
        if (data) {
            this.activeRow = data.activeRow && !(<any>data.activeRow).toJSON ? new IsiDtoGridViewSelectedRowClientState(data.activeRow) : <IsiDtoGridViewSelectedRowClientState>this.activeRow;
            this.selectedRows = data.selectedRows && !(<any>data.selectedRows).toJSON ? new IsiDtoGridViewSelectedRowsClientState(data.selectedRows) : <IsiDtoGridViewSelectedRowsClientState>this.selectedRows;
            this.gridState = data.gridState && !(<any>data.gridState).toJSON ? new IsiDtoGridClientState(data.gridState) : <IsiDtoGridClientState>this.gridState;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allGrpRemoved = _data["allGrpRemoved"] !== undefined ? _data["allGrpRemoved"] : false;
            this.columnsState = _data["columnsState"] !== undefined ? _data["columnsState"] : <any>null;
            this.activeRow = _data["activeRow"] ? IsiDtoGridViewSelectedRowClientState.fromJS(_data["activeRow"]) : <any>null;
            this.selectedRows = IsiDtoGridViewSelectedRowsClientState.fromJS(_data["selectedRows"]);
            this.gridViewId = _data["gridViewId"] !== undefined ? _data["gridViewId"] : <any>null;
            this.gridViewFilter = _data["gridViewFilter"] !== undefined ? _data["gridViewFilter"] : <any>null;
            this.allLinesSelected = _data["allLinesSelected"] !== undefined ? _data["allLinesSelected"] : false;
            this.gridState = _data["gridState"] ? IsiDtoGridClientState.fromJS(_data["gridState"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridViewClientState): IsiDtoGridViewClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridViewClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["allGrpRemoved"] = this.allGrpRemoved !== undefined ? this.allGrpRemoved : false;
        data["columnsState"] = this.columnsState !== undefined ? this.columnsState : <any>null;
        data["activeRow"] = this.activeRow != null ? (<any>this.activeRow).toJSON() : <any>null;
        data["selectedRows"] = this.selectedRows.toJSON();
        data["gridViewId"] = this.gridViewId !== undefined ? this.gridViewId : <any>null;
        data["gridViewFilter"] = this.gridViewFilter !== undefined ? this.gridViewFilter : <any>null;
        data["allLinesSelected"] = this.allLinesSelected !== undefined ? this.allLinesSelected : false;
        data["gridState"] = this.gridState != null ? (<any>this.gridState).toJSON() : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoAssociatedViewClientState extends IsiDtoGridViewClientState implements IIsiDtoAssociatedViewClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.GridView.AssociatedView.IsiDtoAssociatedViewClientState, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoAssociatedViewClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoAssociatedViewClientState): IsiDtoAssociatedViewClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAssociatedViewClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoIwsAssociatedViewLinkClientState extends IIsiDataTransferObject  {
    joinLinkedCtrls?: string[];
}
export class IsiDtoIwsAssociatedViewLinkClientState extends IsiDataTransferObject implements IIsiDtoIwsAssociatedViewLinkClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Grid.GridView.AssociatedView.IsiDtoIwsAssociatedViewLinkClientState, Isilog.IsiComponent.IsiDataTransferObject";
    joinLinkedCtrls?: string[];

    constructor(data?: IIsiDtoIwsAssociatedViewLinkClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.joinLinkedCtrls = _data["joinLinkedCtrls"];
        }
    }

    static fromJS(data?: IIsiDtoIwsAssociatedViewLinkClientState): IsiDtoIwsAssociatedViewLinkClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsAssociatedViewLinkClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["joinLinkedCtrls"] = this.joinLinkedCtrls !== undefined ? this.joinLinkedCtrls : [];
        return data;
    }
}
export enum GridType {
    Normal = 0,
    Hierachical = 1,
    Extended = 2,
}
export class IsiDtoIwsAssociatedViewClientState extends IsiDtoAssociatedViewClientState implements IIsiDtoIwsAssociatedViewClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Grid.GridView.AssociatedView.IsiDtoIwsAssociatedViewClientState, Isilog.IsiComponent.IsiDataTransferObject";
    scriptNameForTs?: string;
    linkContext?: IsiDtoIwsAssociatedViewLinkClientState;
    searchType?: number;
    showCounter?: boolean;
    actionAfterDragNDrop?: string;
    autoRefreshPeriod?: number;
    autoRefresh?: boolean;
    gridType?: GridType;
    useTS?: boolean;
    contextId?: string;
    module?: string;
    name?: string;

    constructor(data?: IIsiDtoIwsAssociatedViewClientState) {
        super(data);
        if (data) {
            this.linkContext = data.linkContext && !(<any>data.linkContext).toJSON ? new IsiDtoIwsAssociatedViewLinkClientState(data.linkContext) : <IsiDtoIwsAssociatedViewLinkClientState>this.linkContext;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scriptNameForTs = _data["scriptNameForTs"] !== undefined ? _data["scriptNameForTs"] : <any>null;
            this.linkContext = _data["linkContext"] ? IsiDtoIwsAssociatedViewLinkClientState.fromJS(_data["linkContext"]) : <any>null;
            this.searchType = _data["searchType"] !== undefined ? _data["searchType"] : 0;
            this.showCounter = _data["showCounter"] !== undefined ? _data["showCounter"] : false;
            this.actionAfterDragNDrop = _data["actionAfterDragNDrop"] !== undefined ? _data["actionAfterDragNDrop"] : <any>null;
            this.autoRefreshPeriod = _data["autoRefreshPeriod"] !== undefined ? _data["autoRefreshPeriod"] : 0;
            this.autoRefresh = _data["autoRefresh"] !== undefined ? _data["autoRefresh"] : false;
            this.gridType = _data["gridType"] !== undefined ? _data["gridType"] : GridType.Normal;
            this.useTS = _data["useTS"] !== undefined ? _data["useTS"] : false;
            this.contextId = _data["contextId"] !== undefined ? _data["contextId"] : <any>null;
            this.module = _data["module"] !== undefined ? _data["module"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsAssociatedViewClientState): IsiDtoIwsAssociatedViewClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsAssociatedViewClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["scriptNameForTs"] = this.scriptNameForTs !== undefined ? this.scriptNameForTs : <any>null;
        data["linkContext"] = this.linkContext != null ? (<any>this.linkContext).toJSON() : <any>null;
        data["searchType"] = this.searchType !== undefined ? this.searchType : 0;
        data["showCounter"] = this.showCounter !== undefined ? this.showCounter : false;
        data["actionAfterDragNDrop"] = this.actionAfterDragNDrop !== undefined ? this.actionAfterDragNDrop : <any>null;
        data["autoRefreshPeriod"] = this.autoRefreshPeriod !== undefined ? this.autoRefreshPeriod : 0;
        data["autoRefresh"] = this.autoRefresh !== undefined ? this.autoRefresh : false;
        data["gridType"] = this.gridType !== undefined ? this.gridType : GridType.Normal;
        data["useTS"] = this.useTS !== undefined ? this.useTS : false;
        data["contextId"] = this.contextId !== undefined ? this.contextId : <any>null;
        data["module"] = this.module !== undefined ? this.module : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}
export class IsiDtoAssociatedViewManagerClientState extends IsiDataTransferObject implements IIsiDtoAssociatedViewManagerClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.Grid.GridView.AssociatedView.IsiDtoAssociatedViewManagerClientState, Isilog.IsiComponent.IsiDataTransferObject";
    focusOnDetail?: boolean;
    shownContextId?: string;
    associatedViewPosition?: DetailState;
    isDefaultView?: boolean;
    displayDetailImplicitely?: boolean;
    states?: { [key: string]: IsiDtoIwsAssociatedViewClientState; };

    constructor(data?: IIsiDtoAssociatedViewManagerClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.focusOnDetail = _data["focusOnDetail"] !== undefined ? _data["focusOnDetail"] : false;
            this.shownContextId = _data["shownContextId"] !== undefined ? _data["shownContextId"] : <any>null;
            this.associatedViewPosition = _data["associatedViewPosition"] !== undefined ? _data["associatedViewPosition"] : DetailState.None;
            this.isDefaultView = _data["isDefaultView"] !== undefined ? _data["isDefaultView"] : false;
            this.displayDetailImplicitely = _data["displayDetailImplicitely"] !== undefined ? _data["displayDetailImplicitely"] : false;
            this.states = _data["states"] !== undefined ? _data["states"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoAssociatedViewManagerClientState): IsiDtoAssociatedViewManagerClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoAssociatedViewManagerClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["focusOnDetail"] = this.focusOnDetail !== undefined ? this.focusOnDetail : false;
        data["shownContextId"] = this.shownContextId !== undefined ? this.shownContextId : <any>null;
        data["associatedViewPosition"] = this.associatedViewPosition !== undefined ? this.associatedViewPosition : DetailState.None;
        data["isDefaultView"] = this.isDefaultView !== undefined ? this.isDefaultView : false;
        data["displayDetailImplicitely"] = this.displayDetailImplicitely !== undefined ? this.displayDetailImplicitely : false;
        data["states"] = this.states !== undefined ? this.states : <any>null;
        return data;
    }
}
export interface IIsiDtoMenuManagerClientState extends IIsiDataTransferObject  {
}
export class IsiDtoMenuManagerClientState extends IsiDataTransferObject implements IIsiDtoMenuManagerClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoMenuManagerClientState, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoMenuManagerClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoMenuManagerClientState): IsiDtoMenuManagerClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoMenuManagerClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export class IsiDtoIwsUIClientState extends IsiDtoUIClientState implements IIsiDtoIwsUIClientState {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.IsiDtoIwsUIClientState, Isilog.IsiComponent.IsiDataTransferObject";
    uiActionEntitiesInfoForRedirect?: { [key: string]: IsiDtoIwsUIEntityInfos; };
    uiActionContextIdForRedirect?: string;
    uiActionIdForRedirect?: string;
    uiActionContextId?: string;
    uiActionId?: string;
    formManager?: IsiDtoFormManagerClientState;
    gridManager?: IsiDtoIwsGridManagerClientState;
    associatedViewManager?: IsiDtoAssociatedViewManagerClientState;
    menuManager?: IsiDtoMenuManagerClientState;

    constructor(data?: IIsiDtoIwsUIClientState) {
        super(data);
        if (data) {
            this.formManager = data.formManager && !(<any>data.formManager).toJSON ? new IsiDtoFormManagerClientState(data.formManager) : <IsiDtoFormManagerClientState>this.formManager;
            this.gridManager = data.gridManager && !(<any>data.gridManager).toJSON ? new IsiDtoIwsGridManagerClientState(data.gridManager) : <IsiDtoIwsGridManagerClientState>this.gridManager;
            this.associatedViewManager = data.associatedViewManager && !(<any>data.associatedViewManager).toJSON ? new IsiDtoAssociatedViewManagerClientState(data.associatedViewManager) : <IsiDtoAssociatedViewManagerClientState>this.associatedViewManager;
            this.menuManager = data.menuManager && !(<any>data.menuManager).toJSON ? new IsiDtoMenuManagerClientState(data.menuManager) : <IsiDtoMenuManagerClientState>this.menuManager;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uiActionEntitiesInfoForRedirect = _data["uiActionEntitiesInfoForRedirect"] !== undefined ? _data["uiActionEntitiesInfoForRedirect"] : <any>null;
            this.uiActionContextIdForRedirect = _data["uiActionContextIdForRedirect"] !== undefined ? _data["uiActionContextIdForRedirect"] : <any>null;
            this.uiActionIdForRedirect = _data["uiActionIdForRedirect"] !== undefined ? _data["uiActionIdForRedirect"] : <any>null;
            this.uiActionContextId = _data["uiActionContextId"] !== undefined ? _data["uiActionContextId"] : <any>null;
            this.uiActionId = _data["uiActionId"] !== undefined ? _data["uiActionId"] : <any>null;
            this.formManager = _data["formManager"] ? IsiDtoFormManagerClientState.fromJS(_data["formManager"]) : <any>null;
            this.gridManager = _data["gridManager"] ? IsiDtoIwsGridManagerClientState.fromJS(_data["gridManager"]) : <any>null;
            this.associatedViewManager = _data["associatedViewManager"] ? IsiDtoAssociatedViewManagerClientState.fromJS(_data["associatedViewManager"]) : <any>null;
            this.menuManager = _data["menuManager"] ? IsiDtoMenuManagerClientState.fromJS(_data["menuManager"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoIwsUIClientState): IsiDtoIwsUIClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoIwsUIClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["uiActionEntitiesInfoForRedirect"] = this.uiActionEntitiesInfoForRedirect !== undefined ? this.uiActionEntitiesInfoForRedirect : <any>null;
        data["uiActionContextIdForRedirect"] = this.uiActionContextIdForRedirect !== undefined ? this.uiActionContextIdForRedirect : <any>null;
        data["uiActionIdForRedirect"] = this.uiActionIdForRedirect !== undefined ? this.uiActionIdForRedirect : <any>null;
        data["uiActionContextId"] = this.uiActionContextId !== undefined ? this.uiActionContextId : <any>null;
        data["uiActionId"] = this.uiActionId !== undefined ? this.uiActionId : <any>null;
        data["formManager"] = this.formManager != null ? (<any>this.formManager).toJSON() : <any>null;
        data["gridManager"] = this.gridManager != null ? (<any>this.gridManager).toJSON() : <any>null;
        data["associatedViewManager"] = this.associatedViewManager != null ? (<any>this.associatedViewManager).toJSON() : <any>null;
        data["menuManager"] = this.menuManager != null ? (<any>this.menuManager).toJSON() : <any>null;
        return data;
    }
}
export class IsiDtoMenuBase extends IsiDataTransferObject implements IIsiDtoMenuBase {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Menu.IsiDtoMenuBase, Isilog.IsiComponent.IsiDataTransferObject";
    data?: { [key: string]: string; };
    id?: string;

    constructor(data?: IIsiDtoMenuBase) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoMenuBase): IsiDtoMenuBase {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoMenuBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
export class IsiDtoMenuObject extends IsiDtoMenuBase implements IIsiDtoMenuObject {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.Menu.IsiDtoMenuObject, Isilog.IsiComponent.IsiDataTransferObject";
    isVisble?: boolean;
    optionUrl?: string;
    key?: string;
    clientIds?: string[];
    shortLabel?: string;
    label?: string;
    group?: string;
    bar?: string;

    constructor(data?: IIsiDtoMenuObject) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isVisble = _data["isVisble"] !== undefined ? _data["isVisble"] : false;
            this.optionUrl = _data["optionUrl"] !== undefined ? _data["optionUrl"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.clientIds = _data["clientIds"];
            this.shortLabel = _data["shortLabel"] !== undefined ? _data["shortLabel"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.bar = _data["bar"] !== undefined ? _data["bar"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoMenuObject): IsiDtoMenuObject {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoMenuObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["isVisble"] = this.isVisble !== undefined ? this.isVisble : false;
        data["optionUrl"] = this.optionUrl !== undefined ? this.optionUrl : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["clientIds"] = this.clientIds !== undefined ? this.clientIds : [];
        data["shortLabel"] = this.shortLabel !== undefined ? this.shortLabel : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["bar"] = this.bar !== undefined ? this.bar : <any>null;
        return data;
    }
}
export interface IIsiDtoPresentationLogicResponse extends IIsiDtoHttpHandlerResponseV4  {
}
export interface IIsiDtoPresentationLogicRequest extends IIsiDtoHttpHandlerRequestV4  {
    response?: IIsiDtoPresentationLogicResponse;
}
export class IsiDtoPresentationLogicResponse extends IsiDtoHttpHandlerResponseV4 implements IIsiDtoPresentationLogicResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.IsiDtoPresentationLogicResponse, Isilog.IsiComponent.IsiDataTransferObject";

    constructor(data?: IIsiDtoPresentationLogicResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoPresentationLogicResponse): IsiDtoPresentationLogicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPresentationLogicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export abstract class IsiDtoPresentationLogicRequest extends IsiDtoHttpHandlerRequestV4 implements IIsiDtoPresentationLogicRequest {
    response?: IsiDtoPresentationLogicResponse;

    constructor(data?: IIsiDtoPresentationLogicRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPresentationLogicResponse(data.response) : <IsiDtoPresentationLogicResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPresentationLogicResponse.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPresentationLogicRequest): IsiDtoPresentationLogicRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IsiDtoPresentationLogicRequest' cannot be instantiated.");
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
